(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vpc-product-card-styles"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    const knop = event.target.closest('.vpc__toevoegen');
    if (!knop || knop.disabled) return;

    const variantId = knop.getAttribute('data-variant-id');
    if (!variantId) return;

    knop.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: 'cart-drawer-section',
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Kon niet toevoegen aan winkelmandje');
        }
        return response.json();
      })
      .then(function (data) {
        // Winkelmandpaneel verversen met de HTML die Shopify's Section
        // Rendering API meteen meestuurt (dezelfde manier waarop dit
        // thema het paneel normaal ververst), zodat de inhoud klopt en
        // niet enkel het cijfer op het tasje-icoon.
        if (data.sections && data.sections['cart-drawer-section']) {
          var wrapper = document.getElementById('shopify-section-cart-drawer-section');
          if (wrapper) {
            var tijdelijk = document.createElement('div');
            tijdelijk.innerHTML = data.sections['cart-drawer-section'];
            var vers = tijdelijk.firstElementChild;
            if (vers) {
              wrapper.replaceWith(vers);
            }
          }
        }

        return fetch('/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        knop.classList.add('is-toegevoegd');

        document
          .querySelectorAll('.cart-bubble__text-count, [ref="cartBubbleCount"]')
          .forEach(function (el) {
            el.textContent = cart.item_count;
            // Zonder dit blijft de bel onzichtbaar als de winkelmand nog
            // leeg was bij het laden van de pagina (cart-bubble.liquid
            // rendert dan server-side een "hidden" class op deze span).
            el.classList.toggle('hidden', cart.item_count === 0);
          });
        document.querySelectorAll('.cart-bubble').forEach(function (el) {
          // Zelfde verhaal voor de bel zelf: "visually-hidden" komt server-side
          // mee wanneer de winkelmand leeg was, en moet hier weg als er nu wel
          // iets in zit.
          el.classList.toggle('visually-hidden', cart.item_count === 0);
        });
        document.querySelectorAll('cart-icon').forEach(function (el) {
          el.classList.toggle('header-actions__cart-icon--has-cart', cart.item_count > 0);
        });
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { cart: cart } }));

        setTimeout(function () {
          knop.classList.remove('is-toegevoegd');
          knop.disabled = false;
        }, 1800);
      })
      .catch(function () {
        knop.disabled = false;
      });
  });
  } catch(e) { console.error(e); }
})();

})();
